import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { Controller } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import { FormHelperText } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
const BootstrapInput = styled(InputBase)(() => ({
  '& .MuiInputBase-input': {
    position: 'relative',
    border: '1px solid #E0E0E0',
    '&:focus': {
      borderColor: 'none',
    },
  },
}));

// 기본 화살표 아이콘
const DefaultChevronIcon = props => (
  <img
    {...props}
    style={{ margin: '-4px 12px 0px 12px', cursor: 'pointer' }}
    src="/images/icons/chevron-down.svg"
    alt="chevron-down"
  />
);

export const FormInputDropdown = ({
  name = 'name',
  control = {},
  sx,
  options,
  rules,
  staticValue,
  disabled,
  onChange: onChangeProp, // rename to avoid conflicts with internal onChange
  placeholder,
  disabledItem = <div />,
  renderOption, // 커스텀 옵션 렌더링 함수
  renderValue: renderValueProp, // 선택된 값 표시 커스터마이징 함수
  IconComponent: CustomIconComponent, // 커스텀 아이콘 컴포넌트
}) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const generateSingleOptions = value => {
    return options?.map(option => (
      <MenuItem key={option.value} selected={option.value === value} value={option.value}>
        {renderOption ? renderOption(option) : t(option.label)}
      </MenuItem>
    ));
  };

  // 선택된 값을 표시하는 함수
  const getSelectedLabel = selectedValue => {
    if (!selectedValue && selectedValue !== 0) {
      return placeholder ? <span style={{ color: '#a6a6a6' }}>{t(placeholder)}</span> : '';
    }
    const selectedOption = options?.find(opt => opt.value === selectedValue);
    if (!selectedOption) {
      return placeholder ? <span style={{ color: '#a6a6a6' }}>{t(placeholder)}</span> : '';
    }
    if (renderValueProp) return renderValueProp(selectedOption);
    return t(selectedOption.label);
  };

  return (
    <FormControl variant="standard" sx={sx} size={'small'}>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value }, fieldState: { error } }) => {
          const handleChange = e => {
            onChange(e);
            if (onChangeProp) {
              onChangeProp(e);
            }
          };

          return (
            <>
              <Select
                error={!!error}
                displayEmpty
                sx={{
                  textAlign: 'start',
                  height: '50%',
                  '&&.Mui-error': {
                    '.MuiInputBase-input': {
                      borderColor: theme.palette.error.main,
                    },
                  },
                }}
                placeholder={placeholder}
                onChange={handleChange}
                value={value ?? staticValue}
                disabled={disabled}
                input={<BootstrapInput />}
                key={value}
                IconComponent={CustomIconComponent || DefaultChevronIcon}
                renderValue={renderOption ? getSelectedLabel : undefined}>
                {disabledItem}
                {generateSingleOptions(value)}
              </Select>
            </>
          );
        }}
      />
    </FormControl>
  );
};
